import * as React from 'react';

export function ProblemSection() {
  return (
    <section className="ong-problem">
      <style>{`
        .ong-problem {
          padding: 72px 24px;
          background: #fafaf7;
        }
        .ong-problem-inner {
          max-width: 720px;
          margin: 0 auto;
        }
        .ong-problem h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 8px;
          line-height: 1.3;
        }
        .ong-problem .accent {
          font-size: 22px;
          font-weight: 600;
          color: #c53030;
          margin: 0 0 28px;
        }
        .ong-problem p {
          font-size: 16px;
          color: #444;
          line-height: 1.7;
          margin: 0 0 20px;
        }
        .ong-problem .highlight {
          font-weight: 600;
          color: #1a1a1a;
        }
        .ong-fail-list {
          list-style: none;
          padding: 0;
          margin: 24px 0 0;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
        }
        .ong-fail-list li {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 15px;
          color: #555;
          padding: 10px 14px;
          background: #fef2f2;
          border-radius: 8px;
        }
        .ong-fail-list li i {
          color: #c53030;
          font-size: 14px;
          flex-shrink: 0;
        }
        @media (max-width: 640px) {
          .ong-problem h2 {
            font-size: 24px;
          }
          .ong-fail-list {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
      <div className="ong-problem-inner">
        <h2>Gestionar un comedor social ya es un desafío enorme.</h2>
        <p className="accent">Un proveedor que falla lo hace insostenible.</p>
        <p>
          Los presupuestos son ajustados, los beneficiarios dependen de cada comida, y hay que rendir cuentas.
          Lo último que necesitás es <span className="highlight">un proveedor informal que complique todo</span>.
        </p>
        <p className="highlight">Un proveedor poco confiable genera:</p>
        <ul className="ong-fail-list">
          <li><i className="fa fa-times-circle" /> Presupuestos que no cierran</li>
          <li><i className="fa fa-times-circle" /> Productos que llegan en mal estado</li>
          <li><i className="fa fa-times-circle" /> Sin factura para las rendiciones</li>
          <li><i className="fa fa-times-circle" /> Entregas impredecibles</li>
        </ul>
      </div>
    </section>
  );
}
